// List of supported languages
const languages = ['fr', 'en', 'es'];

export default languages;
